import _initializerDefineProperty from "@babel/runtime-corejs3/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime-corejs3/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime-corejs3/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10;
import { action, runInAction, observable, toJS } from 'mobx';
import { BrowseNavigationItemSelected, BrowseNavigationItemStyle, BrowseNavigationItemType } from '@udemy/browse-event-tracking';
import { Tracker as tracker } from '@udemy/event-tracking';
import { AIAssistantEntryPointSelected, LearningAssistantChatTypeOptions, LearningAssistantEntryPointUIRegionOptions } from '@udemy/react-learning-assistant-entry-points';
import { debounce, udExpiringLocalStorage } from '@udemy/shared-utils';
import { AGGREGATOR_NAV, ACADEMIES_TYPE, CERTIFICATION_TYPE, BADGING_NAV, BROWSE_LEARNING_TYPES, BROWSE_TYPE, AI_ASSISTANT_NAV, ROLE_PLAY_NAV, AI_ELEVATE_NAV } from '../../browse-constants';
import { SUBCATEGORY_NOT_IN_PERSONAL_PLAN } from '../../constants';
import { AIAssistantNavItemType, BadgeNavItemSelectEvent, CategoryNavItemSelectEvent, GoogleCertificateNavItemType, GWG_CERTIFICATION_TYPE, LearningTypeNavItemSelectEvent, AILearningNavItemType } from '../../events';
import { loadCommonAppContext } from '../../external/load-common-app-context';
import { fetchAggregatorTopics } from '../../fetch-aggregator-topics';
import { MOST_POPULAR_SUBCATEGORY_IDS, fetchPopularTopicsForSubcategory } from '../../fetch-popular-topics';
import { useAiTopicsQuery } from '../../graphql/api-platform-graphql';
import { aiTopicIdsByCategory } from '../../utils/constants';
export let BrowseNavStore = (_dec = observable.ref, _dec2 = observable.ref, _dec3 = observable.ref, _dec4 = observable.ref, _dec5 = observable.ref, _dec6 = observable.ref, _dec7 = observable.ref, _dec8 = observable.ref, _class = class BrowseNavStore {
  constructor(gettext, _locale, lang, navigation_locale, _isUFB = false) {
    this._localStorage = void 0;
    this._debouncedLoadTopics = void 0;
    _initializerDefineProperty(this, "aggregatorIssuers", _descriptor, this);
    _initializerDefineProperty(this, "aggregatorSubjects", _descriptor2, this);
    _initializerDefineProperty(this, "navigationCategories", _descriptor3, this);
    _initializerDefineProperty(this, "mostPopularSubcategories", _descriptor4, this);
    _initializerDefineProperty(this, "aggregatorNavCategory", _descriptor5, this);
    this._topics = observable.map({}, {
      deep: false
    });
    _initializerDefineProperty(this, "selectedLevelOneItem", _descriptor6, this);
    _initializerDefineProperty(this, "selectedLevelTwoItem", _descriptor7, this);
    _initializerDefineProperty(this, "selectedLevelThreeItem", _descriptor8, this);
    this.commonAppContext = void 0;
    this.loadNavigationAggregatorTopics = async () => {
      var _aggregatorData$issue, _aggregatorData$subje;
      if (this.aggregatorIssuers.length || this.aggregatorSubjects.length) {
        return;
      }
      const aggregatorData = await fetchAggregatorTopics();
      function mapAggregatorData(category, type) {
        return {
          id: category.item.id,
          title: category.item.title,
          absolute_url: category.item.url,
          type: type,
          children: category.sub_items.map(subItem => {
            return {
              id: subItem.id,
              title: subItem.title,
              absolute_url: subItem.url,
              type: CERTIFICATION_TYPE.CERTIFICATION_TOPIC
            };
          })
        };
      }
      const aggregatorIssuers = aggregatorData === null || aggregatorData === void 0 || (_aggregatorData$issue = aggregatorData.issuers) === null || _aggregatorData$issue === void 0 ? void 0 : _aggregatorData$issue.map(issuer => {
        return mapAggregatorData(issuer, CERTIFICATION_TYPE.CERTIFICATION_ISSUER_AGGREGATOR);
      });
      const aggregatorSubjects = aggregatorData === null || aggregatorData === void 0 || (_aggregatorData$subje = aggregatorData.subjects) === null || _aggregatorData$subje === void 0 ? void 0 : _aggregatorData$subje.map(issuer => {
        return mapAggregatorData(issuer, CERTIFICATION_TYPE.CERTIFICATION_SUBJECT_AGGREGATOR);
      });
      runInAction(() => {
        this.aggregatorIssuers = aggregatorIssuers;
        this.aggregatorSubjects = aggregatorSubjects;
      });
    };
    this.loadNavigationCategories = async (locale, isUFB = false) => {
      // TODO: move common app context to argument (will require more unit test updates)
      if (!this.commonAppContext) {
        this.commonAppContext = await loadCommonAppContext(locale, isUFB);
      }
      const commonAppContext = this.commonAppContext;
      const headerData = commonAppContext.data.header;
      const {
        user
      } = headerData;
      if (!headerData.navigationCategories) {
        return;
      }

      // Map header data to `navigateCategories` structure
      const navigationCategories = headerData.navigationCategories.map(({
        sd_tag: category,
        sublist
      }) => {
        // Build children from sublist categories
        const navigationCategoriesChildren = sublist.items.map(({
          sd_tag: subcategory
        }) => {
          // If user has a consumer subscription, exclude some subcategories
          if (user.consumer_subscription_active && SUBCATEGORY_NOT_IN_PERSONAL_PLAN.includes(subcategory.id)) {
            return null;
          }
          return {
            id: subcategory.id,
            title: subcategory.title,
            absolute_url: subcategory.url,
            type: BROWSE_TYPE.SUBCATEGORY
          };
        });
        const navigationCategory = {
          id: category.id,
          title: category.title,
          absolute_url: category.url,
          type: BROWSE_TYPE.CATEGORY,
          children: navigationCategoriesChildren.filter(Boolean)
        };
        return navigationCategory;
      });
      runInAction(() => {
        this.navigationCategories = navigationCategories;
      });
    };
    _initializerDefineProperty(this, "selectLevelOneItem", _descriptor9, this);
    _initializerDefineProperty(this, "selectLevelTwoItem", _descriptor0, this);
    _initializerDefineProperty(this, "selectLevelThreeItem", _descriptor1, this);
    this.trackSelect = () => {
      this._trackSelect({
        selectedVia: 'click'
      });
    };
    this.loadMostPopularTopicsForSubcategories = async () => {
      let popularSubcategories = this.navigationCategories.reduce((acc, {
        children
      }) => [...acc, ...children], []).filter(({
        id
      }) => MOST_POPULAR_SUBCATEGORY_IDS.includes(id));
      await Promise.all(popularSubcategories.map(subcat => {
        this._loadTopics(subcat, this.isUFB);
      }));
      popularSubcategories = popularSubcategories.map(subcat => ({
        ...subcat,
        popularTopics: this.getTopics(subcat)
      }));
      runInAction(() => {
        this.mostPopularSubcategories = popularSubcategories;
      });
    };
    _initializerDefineProperty(this, "_loadTopics", _descriptor10, this);
    this.gettext = gettext;
    this.locale = _locale;
    this.lang = lang;
    this.navigation_locale = navigation_locale;
    this.isUFB = _isUFB;
    const expirationDate = new Date(Date.now() + 4 * 3600 * 1000);
    this._localStorage = udExpiringLocalStorage('header-browse-nav', 'items', expirationDate);
    this._debouncedLoadTopics = debounce(this._loadTopics, 150);
    this.aggregatorNavCategory = AGGREGATOR_NAV(this.gettext).AGGREGATORS;
  }
  _trackSelect(options) {
    if (options.selectedVia === 'click') {
      // AI Navigation topic event
      if (options.aiNavigationTopicId) {
        tracker.publishEvent(new BrowseNavigationItemSelected({
          id: options.aiNavigationTopicId,
          type: BrowseNavigationItemType.TOPIC,
          uiRegion: 'main_nav',
          style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN,
          relatedEntityType: BrowseNavigationItemType.TOPIC
        }));
        return;
      }
      // Event will vary depending on if it's a learning type nav item (labs, assessments)
      if (options.learningItemType) {
        tracker.publishEvent(new LearningTypeNavItemSelectEvent(options.learningItemType));
      } else if (options.badgeItemType) {
        tracker.publishEvent(new BadgeNavItemSelectEvent(options.badgeItemType));
      } else if (options.aiAssistantNavItemType) {
        switch (options.aiAssistantNavItemType) {
          case AIAssistantNavItemType.DISCOVERY:
            tracker.publishEvent(new AIAssistantEntryPointSelected({
              chatType: LearningAssistantChatTypeOptions.DISCOVERY_CHAT,
              uiRegion: LearningAssistantEntryPointUIRegionOptions.HEADER_NAV
            }));
            break;
        }
      } else if (options.aiElevateNavItemType) {
        tracker.publishEvent(new BrowseNavigationItemSelected({
          id: '-1',
          type: BrowseNavigationItemType.AI_COURSES,
          uiRegion: 'main_nav',
          style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN
        }));
      } else if (options.aggregatorNavItemType && this.selectedLevelOneItem) {
        var _this$selectedLevelTh, _this$selectedLevelTw, _this$selectedLevelTw2, _this$selectedLevelTw3;
        const context = {
          id: String(((_this$selectedLevelTh = this.selectedLevelThreeItem) === null || _this$selectedLevelTh === void 0 ? void 0 : _this$selectedLevelTh.id) || ((_this$selectedLevelTw = this.selectedLevelTwoItem) === null || _this$selectedLevelTw === void 0 ? void 0 : _this$selectedLevelTw.id) || this.selectedLevelOneItem.id),
          relatedEntityId: (_this$selectedLevelTw2 = this.selectedLevelTwoItem) === null || _this$selectedLevelTw2 === void 0 ? void 0 : _this$selectedLevelTw2.id,
          relatedEntityType: (_this$selectedLevelTw3 = this.selectedLevelTwoItem) === null || _this$selectedLevelTw3 === void 0 ? void 0 : _this$selectedLevelTw3.type,
          uiRegion: 'main_nav',
          style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN,
          // certificaiton_topic is still considered a topic for event tracking purposes
          type: options.aggregatorNavItemType === CERTIFICATION_TYPE.CERTIFICATION_TOPIC ? BrowseNavigationItemType.TOPIC : options.aggregatorNavItemType
        };
        tracker.publishEvent(new BrowseNavigationItemSelected(context));
      } else if (options.academiesNavItemType) {
        var _this$selectedLevelTw4;
        const possibleItems = [this.selectedLevelThreeItem, this.selectedLevelTwoItem, this.selectedLevelOneItem];
        let id = undefined;
        for (const item of possibleItems) {
          if (item && 'slug' in item) {
            id = item.slug;
          }
        }
        const context = {
          id: id !== null && id !== void 0 ? id : '-1',
          uiRegion: 'main_nav',
          style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN,
          type: options.academiesNavItemType,
          relatedEntityType: this.selectedLevelOneItem ? (_this$selectedLevelTw4 = this.selectedLevelTwoItem) === null || _this$selectedLevelTw4 === void 0 ? void 0 : _this$selectedLevelTw4.type : undefined
        };
        tracker.publishEvent(new BrowseNavigationItemSelected(context));
      } else if (options.rolePlayNavItemType) {
        const context = {
          id: '-1',
          uiRegion: 'main_nav',
          style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN,
          type: options.rolePlayNavItemType
        };
        tracker.publishEvent(new BrowseNavigationItemSelected(context));
      } else if (options.googleCertificateNavItemType) {
        // Determine the ID based on the selected item (use URL as ID)
        const selectedItem = this.selectedLevelTwoItem || this.selectedLevelOneItem;
        const itemId = typeof (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.absolute_url) === 'string' ? selectedItem.absolute_url : '-1';
        tracker.publishEvent(new BrowseNavigationItemSelected({
          id: itemId,
          type: GWG_CERTIFICATION_TYPE,
          uiRegion: 'main_nav',
          style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN
        }));
      } else if (this.selectedLevelOneItem) {
        var _this$selectedLevelTw5, _this$selectedLevelTh2;
        const context = {
          categoryId: this.selectedLevelOneItem.id,
          subcategoryId: (_this$selectedLevelTw5 = this.selectedLevelTwoItem) === null || _this$selectedLevelTw5 === void 0 ? void 0 : _this$selectedLevelTw5.id,
          topicId: (_this$selectedLevelTh2 = this.selectedLevelThreeItem) === null || _this$selectedLevelTh2 === void 0 ? void 0 : _this$selectedLevelTh2.id,
          uiRegion: 'main_nav'
        };
        tracker.publishEvent(new CategoryNavItemSelectEvent({
          context
        }));
      }
    }
  }
  _selectItem(selectedItemKey, item, givenOptions) {
    var _this$selectedLevelOn;
    const options = {
      toggle: true,
      ...givenOptions
    };

    // Identify the type of item being selected in order to fire appropriate event
    // Special case: AI Navigation topic selection
    if (((_this$selectedLevelOn = this.selectedLevelOneItem) === null || _this$selectedLevelOn === void 0 ? void 0 : _this$selectedLevelOn.type) === AILearningNavItemType.LEARN_AI && typeof item.absolute_url === 'string' && item.absolute_url.includes('/topic/')) {
      var _item$absolute_url$sp;
      options.aiNavigationTopicId = ((_item$absolute_url$sp = item.absolute_url.split('/topic/')[1]) === null || _item$absolute_url$sp === void 0 ? void 0 : _item$absolute_url$sp.replace(/\/$/, '')) || '';
    }
    if (Object.values(BROWSE_LEARNING_TYPES(this.gettext)).map(item => item.type).includes(item.type)) {
      options.learningItemType = item.type;
    } else if (Object.values(BADGING_NAV(this.gettext)).map(item => item.type).includes(item.type)) {
      options.badgeItemType = item.type;
    } else if (Object.values(CERTIFICATION_TYPE).includes(item.type)) {
      options.aggregatorNavItemType = item.type;
    } else if (Object.values(ACADEMIES_TYPE).includes(item.type)) {
      options.academiesNavItemType = item.type;
    } else if (Object.values(AI_ASSISTANT_NAV(this.gettext)).map(item => item.type).includes(item.type)) {
      options.aiAssistantNavItemType = item.type;
    } else if (Object.values(AI_ELEVATE_NAV(this.gettext)).map(item => item.type).includes(item.type)) {
      options.aiElevateNavItemType = item.type;
    } else if (Object.values(ROLE_PLAY_NAV(this.gettext)).map(item => item.type).includes(item.type)) {
      options.rolePlayNavItemType = item.type;
    } else if (item.type === GoogleCertificateNavItemType.GOOGLE_CERTIFICATES || item.type === GoogleCertificateNavItemType.GOOGLE_CERTIFICATE_PATH) {
      options.googleCertificateNavItemType = item.type;
    }

    /* eslint-disable @typescript-eslint/no-explicit-any */
    if (item === this[selectedItemKey] && options.toggle) {
      this[selectedItemKey] = null;
    } else {
      this[selectedItemKey] = item;
      this._trackSelect(options);
    }
    /* eslint-enable @typescript-eslint/no-explicit-any */
  }
  getTopics(subcategory) {
    return this._topics.get(subcategory.id);
  }
  /**
   * Private: Fetches AI topics from GraphQL using the provided topic IDs.
   *
   * @param ids - Array of topic IDs to fetch
   * @returns Promise resolving to an array of topics with id, name, url, and type
   */
  async fetchAiTopicsWithGraphQL(ids) {
    // Call the fetcher and await the response
    const gqlResponse = await useAiTopicsQuery.fetcher({
      ids
    })();
    // Defensive: handle missing or malformed response
    if (!gqlResponse || !gqlResponse.topics) {
      return [];
    }
    // Return the topics array mapped to SDTag
    return gqlResponse.topics.map(topic => ({
      id: Number(topic.id),
      title: topic.name,
      absolute_url: topic.url,
      type: BROWSE_TYPE.TOPIC
    }));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "aggregatorIssuers", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "aggregatorSubjects", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "navigationCategories", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "mostPopularSubcategories", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "aggregatorNavCategory", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedLevelOneItem", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectedLevelTwoItem", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "selectedLevelThreeItem", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "selectLevelOneItem", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (item, options = {}) => {
      this._selectItem('selectedLevelOneItem', item, options);
      this.selectedLevelTwoItem = null;
      this.selectedLevelThreeItem = null;
    };
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "selectLevelTwoItem", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (item, options = {}) => {
      this._selectItem('selectedLevelTwoItem', item, options);
      this.selectedLevelThreeItem = null;
      if (this.selectedLevelTwoItem === item && item.type === BROWSE_TYPE.SUBCATEGORY) {
        this._debouncedLoadTopics(item, this.isUFB);
      }
    };
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "selectLevelThreeItem", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (item, options = {}) => {
      this._selectItem('selectedLevelThreeItem', item, options);
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_loadTopics", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return async (subcategory, isUFB = false) => {
      var _this$selectedLevelOn2;
      // If this is an AI learning subcategory, handle it differently
      if (((_this$selectedLevelOn2 = this.selectedLevelOneItem) === null || _this$selectedLevelOn2 === void 0 ? void 0 : _this$selectedLevelOn2.type) === AILearningNavItemType.LEARN_AI) {
        // Get the slug from the subcategory's title
        const slug = subcategory.slug;
        const category = aiTopicIdsByCategory.find(cat => cat.slug === slug);
        if (category) {
          // Check if topics already exist for this subcategory and are non-empty
          const existingTopics = this._topics.get(subcategory.id);
          if (existingTopics && existingTopics.length > 0) {
            return; // Topics already fetched, skip fetching again
          }
          // Fetch topics from GraphQL using the new implementation
          const topics = await this.fetchAiTopicsWithGraphQL(category.ids);
          this._topics.set(subcategory.id, topics);
          return;
        }
      }

      // For non-AI learning topics, use the existing logic
      if (!this.commonAppContext) {
        this.commonAppContext = await loadCommonAppContext(this.locale, isUFB);
      }
      const commonAppContext = this.commonAppContext;
      const {
        user
      } = commonAppContext.data.header;
      if (this.getTopics(subcategory)) {
        return Promise.resolve();
      }
      const cacheKey = user.consumer_subscription_active ? `PP:${subcategory.id}:${this.locale}` : `${subcategory.id}:${this.locale}`;
      const cachedTopics = this._localStorage.get(cacheKey);
      if (cachedTopics) {
        this._topics.set(subcategory.id, toJS(cachedTopics));
        return Promise.resolve();
      }
      const params = {
        page_size: 9,
        locale: this.locale
      };
      if (this.navigation_locale) {
        params.navigation_locale = this.navigation_locale;
      }
      try {
        const response = await fetchPopularTopicsForSubcategory(subcategory.id, this.locale, 9, isUFB);
        const topics = response.stats.map(topic => {
          return {
            id: topic.id,
            absolute_url: topic.url,
            title: topic.title,
            type: BROWSE_TYPE.TOPIC
          };
        }).filter(topic => {
          var _subcategory$title;
          return topic.title.toLowerCase() !== ((_subcategory$title = subcategory.title) === null || _subcategory$title === void 0 ? void 0 : _subcategory$title.toLowerCase());
        });
        this._localStorage.set(cacheKey, topics);
        this._topics.set(subcategory.id, topics);
      } catch (e) {
        this._topics.set(subcategory.id, []);
      }
    };
  }
}), _class);
//# sourceMappingURL=browse-nav.mobx-store.js.map